import { render, staticRenderFns } from "./LessonFolderCard.vue?vue&type=template&id=2604cdb1"
import script from "./LessonFolderCard.vue?vue&type=script&lang=js"
export * from "./LessonFolderCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports